<template>
  <div v-if="model">
    <v-row v-if="model.ul">
      <v-col>
        <v-card color="grey lighten-4" class="py-0" elevation="0">
          <v-card-text class="text-h6 py-0">"{{ model.ul.companyName }}"</v-card-text>
          <v-card-text class="text-subtitle-2 py-0">Описание: </v-card-text>
          <div class="text-subtitle-1 ml-4">{{ model.ul.description }}</div>

          <v-card-text class="text-subtitle-2 py-0">На основании:</v-card-text>
          <div class="text-subtitle-1 ml-4">{{ model.ul.based }}</div>
          <v-row class="mt-1">
            <v-col cols="7">
              <v-card-text class="text-subtitle-2 py-0">Адрес компании:</v-card-text>
              <div class="text-subtitle-1 ml-4">г.{{ model.ul.city }}, {{ model.ul.address }}</div>
              <v-card-text class="text-subtitle-2 py-0">Полное ФИО: </v-card-text>
              <div class="text-subtitle-1 ml-4">
                {{ model.ul.firstName }} {{ model.ul.middleName }} {{ model.ul.lastName }}
              </div>
            </v-col>
            <v-col>
              <v-card-text class="text-subtitle-2 py-0">Почта: </v-card-text>
              <div class="text-subtitle-1 ml-4">
                <a :href="`mailto:${model.ul.email}`" class="font">{{ model.ul.email }}</a>
              </div>
              <v-card-text class="text-subtitle-2 py-0">Телефон: </v-card-text>
              <div class="text-subtitle-1 ml-4">
                <a :href="`tel:${model.ul.phoneNumber}`" class="font">{{ formatPhone(model.ul.phoneNumber) }}</a>
              </div>
            </v-col>
          </v-row>
        </v-card>
      </v-col>
    </v-row>

    <v-row>
      <v-col v-if="model.state === 'CheckingPrivatePerson'" cols="12" class="pb-0">
        <v-alert dense type="warning" class="mb-0">
          <div class="d-flex align-center">
            <div class="py-0 mr-4">Статус компании:</div>
            <div class="py-0 text-h6">На проверке</div>
          </div>
        </v-alert>
      </v-col>
      <v-col cols="6">
        <v-card-text class="py-0">Статус личного кабинета: </v-card-text>
        <StatusChip :value="model.lkstatus" class="d-flex justify-center" />
      </v-col>
      <v-col cols="6">
        <v-card-text class="py-0">Восстановление статуса: </v-card-text>
        <StatusChip :value="model.recovery_status" class="d-flex justify-center" />
      </v-col>
    </v-row>

    <hr class="mb-2 mt-4" />
    <v-row v-if="model.coowners || model.ul">
      <v-col cols="6" v-if="model.coowners">
        <v-card-text class="py-0 pb-1 text-subtitle-2">Совладельцы</v-card-text>
        <div v-for="cowneer in model.coowners.report" :key="cowneer.id" class="pb-2">
          <v-card-text class="py-0"
            >Имя:<span class="ml-2"> {{ cowneer.name }}</span></v-card-text
          >
          <v-card-text class="py-0"
            >Тип компании: <span class="ml-2">{{ cowneer.cwtype }}</span></v-card-text
          >
          <v-card-text class="py-0"
            >ИНН: <span class="ml-2">{{ cowneer.inn }}</span></v-card-text
          >
          <v-card-text class="py-0"
            >СТ: <span class="ml-2">{{ cowneer.st }} </span></v-card-text
          >
        </div>
      </v-col>
      <v-col cols="6" v-if="model.ul">
        <v-card color="grey lighten-5" class="pa-1 inn" elevation="0">
          <v-card-text class="d-flex justify-space-between font-weight-medium py-0"
            >absid: <span>{{ model.absid }}</span>
          </v-card-text>
          <v-card-text class="d-flex justify-space-between py-1"
            >ИНН: <span>{{ model.ul.inn }} </span></v-card-text
          >
          <v-card-text class="d-flex justify-space-between font-weight-medium py-0"
            >ОГРН:<span> {{ model.ul.ogrn }}</span>
          </v-card-text>
          <v-card-text class="d-flex justify-space-between py-0"
            >КПП: <span>{{ model.ul.kpp }}</span>
          </v-card-text>
          <v-card-text class="d-flex justify-space-between font-weight-medium py-0"
            >Код отправления:<span> {{ model.ul.departcode }} </span>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <hr class="mt-2 mb-4" />

    <v-row v-if="model.integ" class="mb-4">
      <v-col cols="6">
        <v-card-text class="py-0 text-subtitle-2">Интеграция</v-card-text>
        <div v-for="item in model.integ" :key="item.utm_reg">
          <v-card-text class="py-0"
            >Партнер: <a :href="`https://${item}`" target="_blank"> {{ item }}</a></v-card-text
          >
        </div>
      </v-col>
    </v-row>

    <v-row v-if="model.ul">
      <v-expansion-panels focusable>
        <v-expansion-panel>
          <v-expansion-panel-header>
            Комментарии<v-chip
              small
              class="ml-2"
              style="min-width: 24px; max-width: 24px; width: 24px; padding: 0 9px"
              color="primary"
              text-color="#fff"
              >{{ model.ul.comment }}
            </v-chip>
          </v-expansion-panel-header>
          <v-expansion-panel-content class="py-2" color="grey lighten-4">
            <blockquote>{{ model.ul.comment }}</blockquote></v-expansion-panel-content
          >
        </v-expansion-panel>
      </v-expansion-panels>
    </v-row>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import StatusChip from "@/components/common/StatusChip";
import { formatPhone } from "@/utils/helpers";

export default {
  name: "AppModelLog",

  components: { StatusChip },
  data() {
    return {
      fullInfo: false,
    };
  },

  computed: {
    ...mapGetters("app", ["model"]),
    refreshContent() {
      return this.model.ul?.comment ? this.model.ul?.comment : "0";
    },
  },
  methods: {
    formatPhone(value) {
      return formatPhone(value);
    },
  },
};
</script>

<style lang="scss" scoped>
.header {
  background-color: rgb(55, 167, 241);
  color: white;
}
.v-alert {
  padding-bottom: 3px !important;
  padding-top: 3px !important;
}
.v-alert__icon.v-icon {
  padding-top: 4px;
}
</style>
